import { DEFAULT_ASSET, DEFAULT_METRIC_CODE } from '../../constants/app';

export const GET_INITIAL_TRACES = 'COMPARE/GET_INITIAL_TRACES';

export const getInitialTraces = () => ({
  type: GET_INITIAL_TRACES,
});

export const RELOAD_TRACES = 'COMPARE/RELOAD_TRACES';

export const reloadTraces = () => ({
  type: RELOAD_TRACES,
});

export const GET_TRACE = 'COMPARE/GET_TRACE';
export const GET_TRACE_PENDING = `${GET_TRACE}_PENDING`;
export const GET_TRACE_FULFILLED = `${GET_TRACE}_FULFILLED`;
export const GET_TRACE_REJECTED = `${GET_TRACE}_REJECTED`;

export const getTrace = () => ({
  type: GET_TRACE,
});

export const GET_DEPENDENCY = 'COMPARE/GET_DEPENDENCY';
export const GET_DEPENDENCY_PENDING = `${GET_DEPENDENCY}_PENDING`;
export const GET_DEPENDENCY_FULFILLED = `${GET_DEPENDENCY}_FULFILLED`;
export const GET_DEPENDENCY_REJECTED = `${GET_DEPENDENCY}_REJECTED`;

export const getDependency = () => ({
  type: GET_DEPENDENCY,
});

export const ADD_TRACE = 'COMPARE/ADD_TRACE';

export const addTrace = (asset = DEFAULT_ASSET, metricCode = DEFAULT_METRIC_CODE, options = {}) => ({
  type: ADD_TRACE,
  payload: {
    asset,
    metricCode,
    options,
  },
});

export const DELETE_TRACE = 'COMPARE/DELETE_TRACE';

export const deleteTrace = (idx) => ({
  type: DELETE_TRACE,
  payload: {
    idx,
  },
});

export const RESET_TRACES = 'COMPARE/RESET_TRACES';

export const resetTraces = () => ({
  type: RESET_TRACES,
});

export const CHANGE_ASSET_TRIGGER = 'COMPARE/CHANGE_ASSET_TRIGGER';

export const changeAssetTrigger = (asset, idx) => ({
  type: CHANGE_ASSET_TRIGGER,
  payload: {
    asset,
    idx,
  },
});

export const CHANGE_ASSET = 'COMPARE/CHANGE_ASSET';

export const changeAsset = (asset, idx) => ({
  type: CHANGE_ASSET,
  payload: {
    asset,
    idx,
  },
});

export const CHANGE_METRIC = 'COMPARE/CHANGE_METRIC';

export const changeMetric = (metricCode, idx) => ({
  type: CHANGE_METRIC,
  payload: {
    metricCode,
    idx,
  },
});

export const CHANGE_SCALE = 'COMPARE/CHANGE_SCALE';

export const changeScale = (value, idx) => ({
  type: CHANGE_SCALE,
  payload: {
    value,
    idx,
  },
});

export const CHANGE_MOVING_AVERAGE = 'COMPARE/CHANGE_MOVING_AVERAGE';

export const changeMovingAverage = (value, idx) => ({
  type: CHANGE_MOVING_AVERAGE,
  payload: {
    value,
    idx,
  },
});

export const CHANGE_MOVING_MEDIAN = 'COMPARE/CHANGE_MOVING_MEDIAN';

export const changeMovingMedian = (value, idx) => ({
  type: CHANGE_MOVING_MEDIAN,
  payload: {
    value,
    idx,
  },
});

export const CHANGE_CURRENCY = 'COMPARE/CHANGE_CURRENCY';

export const changeCurrency = (value, idx) => ({
  type: CHANGE_CURRENCY,
  payload: {
    value,
    idx,
  },
});

export const CHANGE_EXCHANGE = 'COMPARE/CHANGE_EXCHANGE';

export const changeExchange = (value, idx) => ({
  type: CHANGE_EXCHANGE,
  payload: {
    value,
    idx,
  },
});

export const RESET_EXCHANGE = 'COMPARE/RESET_EXCHANGE';

export const resetExchange = (idx) => ({
  type: RESET_EXCHANGE,
  payload: {
    idx,
  },
});

export const CHANGE_MINER = 'COMPARE/CHANGE_MINER';

export const changeMiner = (value, idx) => ({
  type: CHANGE_MINER,
  payload: {
    value,
    idx,
  },
});

export const RESET_MINER = 'COMPARE/RESET_MINER';

export const resetMiner = (idx) => ({
  type: RESET_MINER,
  payload: {
    idx,
  },
});

export const CHANGE_RESOLUTION = 'COMPARE/CHANGE_RESOLUTION';

export const changeResolution = (value, idx) => ({
  type: CHANGE_RESOLUTION,
  payload: {
    value,
    idx,
  },
});

export const CHANGE_COLOR = 'COMPARE/CHANGE_COLOR';

export const changeColor = (color, idx) => ({
  type: CHANGE_COLOR,
  payload: {
    color,
    idx,
  },
});

export const DOWNLOAD_IMAGE = 'COMPARE/DOWNLOAD_IMAGE';

export const downloadImage = () => ({
  type: DOWNLOAD_IMAGE,
});
